// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".post-information .card-info__title__box{margin-bottom:2rem}.post-information .card__post-information .card__post{border-width:0;box-shadow:none}.post-information .card__post-information .card__post .card-body{padding:0}", ""]);
// Exports
module.exports = exports;
